import ProfilesIcon from '../../../assets/icons/profiles.svg?react';
import BedIcon from '../../../assets/icons/bed.svg?react';
import { Tag } from '../../UI';
import { BedDistributionPopover } from './BedDistributionPopover';
import { isBedsExceeded } from './kpiSeverity';
import type { WeekKpi } from './types';
import styles from './WeekKpiCell.module.css';

interface PatientsBedsRowProps {
  kpi: WeekKpi;
}

export const PatientsBedsRow = ({ kpi }: PatientsBedsRowProps) => {
  // More admitted patients planned than the location has rooms for, or booked
  // room needs the rooms cannot meet. Beds have no WARNING state, so EXCEEDED
  // is the only severity that reddens the chip — unlike profession hours.
  // The distribution popover shows on every week, not only overbooked ones:
  // how full each kind of room is matters before it overflows.
  const hasOverbooking = isBedsExceeded(kpi);

  return (
    <div className={styles.patientsBedsRow}>
      <Tag
        label={
          <>
            <ProfilesIcon className={styles.counterIcon} aria-hidden="true" />
            {kpi.patientsCount}
          </>
        }
        size="small"
      />
      <Tag
        label={
          <>
            <BedIcon className={styles.counterIcon} aria-hidden="true" />
            {kpi.bedsCount}
          </>
        }
        size="small"
        tooltip={<BedDistributionPopover kpi={kpi} />}
        className={hasOverbooking ? styles.tagError : ''}
      />
    </div>
  );
};
